import { inject, Provider, type EnvironmentProviders } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AUTH_SIGN_IN_ACTION, AUTH_SIGN_OUT_LOCATION, SnackbarComponent, type SignInCallback } from '@easihub/ngx';

export const AUTH_ACTIONS: Provider | EnvironmentProviders = [
  {
    provide: AUTH_SIGN_IN_ACTION,
    useFactory: () => {
      const snackbar = inject(MatSnackBar);
      const router = inject(Router);

      return (async ({ payload }) => {
        const returnUrl = payload.returnUrl || '/';
        await router.navigateByUrl(returnUrl);
        SnackbarComponent.forSuccess(snackbar);
      }) satisfies SignInCallback;
    },
  },
  {
    provide: AUTH_SIGN_OUT_LOCATION,
    useValue: '/sign-out'
  }
];